/*jshint camelcase: false */
'use strict';

import {getLogger} from 'loglevel';

const log = getLogger('RichRelevance');

import $ from 'jquery';
import _ from 'underscore';
import * as config from '../../js/config';
import mediator from '../../js/mediator';

const MAX_PRODUCTS_TO_TRACK = 15;

let _singleton;

export default class RichRelevance {
  constructor() {
    this.productSearchParts = [];
    this.rrComponents = [];
    this.isInitializedR3 = false;
    this._shouldR3Flush = false;
    mediator.on(config.events.richRelevance.addRrComponent, this.addRrComponent, this);
    mediator.on(config.events.richRelevance.initialise, this.initialise, this);
    // => form doesn't have this context but mediator invokes with RichRelevance instance context
    mediator.on(config.events.richRelevance.shouldR3Flush, (shouldR3Flush) => { this.shouldR3Flush = shouldR3Flush; }, this);
  }

  addRrComponent(initFunction) {

    this.rrComponents.push(initFunction);
    if (this.isInitializedR3) {
      log.warn(
        'r3() has already been called so this component will not be initialized',
        initFunction
      );
    }
  }

  initialise() {
    // Rich Relevance is not on the page
    if (typeof window.R3_COMMON === 'undefined') {
      return;
    }

    mediator.on(config.events.cart.added, this.onAddedToCart, this);
    // If ajax wrappers that might contain rich relevance placements have finished loading
    mediator.on(config.events.ajax.wrappersContainingRichRelevanceComplete, this.initializeAddedPlacements, this);

    // Product search events
    if ($('#productSearchContainer').length) {
      // Product search is special, and will handle flushing itself once all the prices have loaded for the page
      mediator.once(config.events.productSearch.pricingPageLoad, this.onSearchPricingReceived, this);
      mediator.once(config.events.pricing.received, this.onSearchPricingReceived, this);
      mediator.once(config.events.pricing.groupedBuyingOptionsReceived, this.onSearchPricingReceived, this);
      return;
    }

    let $richRelevanceAjaxWrappers = $('.AjaxLoader').filter('[data-contains-rr-placement]');
    if (!$richRelevanceAjaxWrappers.length) {
      this.initializeAddedPlacements();
    }
  }

  set shouldR3Flush(shouldR3Flush) {
    this._shouldR3Flush = shouldR3Flush;
  }

  get shouldR3Flush() {
    return this._shouldR3Flush
  }

  /**
   * Add the placements to RR and start the r3() process
   *
   * docs are here:
   * https://developer.richrelevance.com/JavaScript_Integration/Core_JSON_Integration/Home_Page
   */
  initializeAddedPlacements() {
    if (this.rrComponents.length || this.shouldR3Flush) {
      this.rrComponents.forEach(function(initFunction) {
        initFunction();
      });
      this.rrComponents.length = 0; // clear the array
      window.rr_flush_onload();
      window.r3();
      this.isInitializedR3 = true;
      log.warn('Initialized r3() with added components');
    } else {
      log.warn('Did not call r3()', this.rrComponents, this.shouldR3Flush);
    }
  }

  /**
   * @param {object[]} parts
   * @param {string} parts.partId
   * @param {object} parts.productDetails
   * @param {string} parts.productDetails.partId
   */
  onSearchPricingReceived(parts) {
    this.productSearchParts.push(parts);

    // Wait until we have both events fired
    if (this.productSearchParts.length < 2) {
      return;
    }

    // Merge the arrays
    this.productSearchParts = Array.prototype.concat.apply([], this.productSearchParts);

    try {
      var addItemIdMethod = window.R3_COMMON.addItemId;

      if (window.R3_SEARCH) {
        addItemIdMethod = window.R3_SEARCH.addItemId;
      }

      // Limit the number of products that are tracked
      var addItemId = _.before(MAX_PRODUCTS_TO_TRACK + 1, function(partId) {
        addItemIdMethod(partId);
      });

      _.each(this.productSearchParts, function(part) {
        // Page load/ajax load pricing is structured slightly differently
        if (!part.partId && part.productDetails) {
          part.partId = part.productDetails.partId;
        }

        if (part.partId) {
          addItemId(part.partId);
        }
      });

      // Send the tracking call
      this.initializeAddedPlacements();
    } catch (e) {
      log.warn(e);
    }
  }

  /**
   * @param data
   * @param {AddedProduct[]} data.addedProducts
   */
  onAddedToCart(data) {
    if (data.addedProducts) {
      _.forEach(data.addedProducts, addedProduct => {
        // Just send the part id for now. partNumber (sku for Rich Relevance) exists in buying options for search and will be added to pdp post mvp.
        this.trackItemAddedToCart(addedProduct.model.partId || '');

        // When sku is available in the view data attribute on the product landing page:
        //this.trackItemAddedToCart(addedProduct.model.partId || '', addedProduct.model.partNumber || '');
      });
    }
  }

  trackItemAddedToCart(itemId, itemSku) {
    //This method and related object on the window object are rich relevance globals, so need these nasty checks
    //Also, this will only currently work in production site as haven't implemented Rich Relevance for FE site.
    try {
      if (typeof window.r3_addtocart !== 'undefined') {
        if (typeof window.R3_ADDTOCART === 'undefined') {
          window.R3_ADDTOCART = new window.r3_addtocart();
        }

        // Remove an old itemIds from category results
        if (typeof window.R3_CATEGORY !== 'undefined') {
          window.R3_CATEGORY.id = undefined;
          window.R3_CATEGORY.name = undefined;
        }

        // Remove an old itemIds from search results
        window.R3_COMMON.itemIds = undefined;
        window.R3_COMMON.searchTerms = undefined;

        // Change the page type to add_to_cart
        window.R3_COMMON.placementTypes = '';
        window.R3_COMMON.addPlacementType('add_to_cart_page');

        // Clear any previous add to cart items
        window.R3_COMMON.addedToCartItemIds = undefined;

        // Log the item that was added to the cart
        window.R3_ADDTOCART.addItemIdToCart(itemId || '', itemSku || '');

        // Send the tracking
        this.initializeAddedPlacements();
      }
    } catch (e) {
      log.warn(e);
    }
  }

  static singleton() {
    if (typeof _singleton === 'undefined') {
      _singleton = new RichRelevance();
    }
    return _singleton;
  }
}



// WEBPACK FOOTER //
// ./assets/components/RichRelevance/RichRelevance.js